module.exports = __webpack_public_path__ + "static/media/lafise-headset.479e8299.png";